<template>
  <div v-loading="loading">
    <div>
      <el-form
        size="mini"
        label-position="left"
        label-width="250px"
      >
        <el-form-item label="Средняя оценка компетенции ОТ">
          <div style="display: flex">
            <click-to-edit
              :word-limit="6"
              :show-word-limit="true"
              :number-format="{decimals: 2, space:true}"
              digits-only
              style="width: 220px"
              v-model="range.range_from"
              @input="updateRange"
            ></click-to-edit>
          </div>
        </el-form-item>
        <el-form-item label="Средняя оценка компетенции ДО">
          <div style="display: flex">
            <click-to-edit
              :word-limit="6"
              :show-word-limit="true"
              :number-format="{decimals: 2, space:true}"
              digits-only
              style="width: 220px"
              v-model="range.range_to"
              @input="updateRange"
            ></click-to-edit>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <recommendations-component
      v-show="visible"
      :range="range"
    ></recommendations-component>

    <div style="display: flex; justify-content: space-between; margin-top: 20px">
      <div>
        <el-button
          class="ranges-settings-visibility"
          size="mini"
          :icon="visible ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
          @click="toggleRangeVisibility"
        >
          {{ visible ? 'Свернуть': 'Развернуть' }}
        </el-button>
      </div>

      <div>
        <el-popconfirm
          style="margin-left: 15px"
          confirm-button-text='Да'
          cancel-button-text='нет'
          icon="el-icon-question"
          title="Вы уверены, что хотите удалить диапазон?"
          @confirm="deleteRange"
        >
          <el-button
            slot="reference"
            size="mini"
            plain
            icon="far fa-trash-alt"
            :loading="loading"
          >
            Удалить
          </el-button>
        </el-popconfirm>
      </div>
    </div>
  </div>
</template>

<script>
import RecommendationsComponent from "@/modules/evaluation/components/recommendation/RecommendationsComponent.vue";
import ClickToEdit from "@/components/ClickToEdit.vue";
import PageHeading from "@/components/PageHeading.vue";

export default {
  name: "range-recommendations",
  components: {PageHeading, ClickToEdit, RecommendationsComponent},
  props: {
    range: {type: Object, required: true},
  },
  data() {
    return {
      loading: false,
      visible: false,
    }
  },
  mounted() {
    const visibleSettings = JSON.parse( localStorage.getItem('rangesVisibility') || '{}' );
    this.visible = visibleSettings[this.range.id] || false;
  },
  methods: {
    toggleRangeVisibility(){
      this.visible = !this.visible;
      let settings = JSON.parse( localStorage.getItem('rangesVisibility') || '{}' );
      settings[this.range.id] = this.visible;
      localStorage.setItem('rangesVisibility', JSON.stringify(settings));
    },
    updateRange() {
      this.loading = true;

      this.$api.evaluation.rangeUpdate({
        id: this.range.id,
        range_from: this.range.range_from ?? null,
        range_to: this.range.range_to ?? null,
      })
        .then(data => {
          this.$emit('range-update');
          this.$notify.success({
            title: 'Обновлено',
            message: 'Диапазон успешно обновлен'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    deleteRange() {
      this.loading = true;
      this.$api.evaluation.rangeDelete({
        ids: [this.range.id]
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Диапазон успешно удален'
          });
          this.$emit('range-update');
        })
        .finally(() => {
          this.loading = false;
        })
    },
  }
}
</script>